<template>
  <q-layout>
    <q-page padding>
      <div class="page-header">
        <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('my_invoices') }}</q-toolbar-title>
        <q-breadcrumbs class="q-mr-auto q-ma-sm">
          <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
          <q-breadcrumbs-el :label="$t('my_invoices')" exact />
        </q-breadcrumbs>
      </div>
      <q-separator spaced />
      <header-invoices :id="getProfiles.affiliate_id"></header-invoices>
      <InvoiceNFImagePopUp ref="filePopUp" />
      <list-invoices v-on:showNfPopUp="handleShowPopUp" :id="getProfiles.affiliate_id"></list-invoices>
    </q-page>
  </q-layout>
</template>

<script>
import HeaderInvoices from '../../components/affiliate/HeaderInvoices.vue';
import ListInvoices from '../../components/affiliate/ListInvoices.vue';
import InvoiceNFImagePopUp from '../../components/affiliate/financial/InvoiceNFImagePopUp.vue';

export default {
  name: 'Invoices',
  components: { HeaderInvoices, ListInvoices, InvoiceNFImagePopUp },
  methods: {
    handleShowPopUp(row) {
      this.$refs.filePopUp.getNfFileURL(row);
    }
  },

  computed: {
    getProfiles: {
      get() {
        return this.$store.state.Account.user;
      }
    }
  }
};
</script>
